import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AreaFilter from "../../components/area/area-filter";
import AreaTable from "../../components/area/area-table";
import SearchFilterCard from "../../components/general/filter-card";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import AppContext from "../../context/app/context";
import AreaContext from "../../context/area/context";
import AreaContextProvider from "../../context/area/provider";
import { useIsMount } from "../../utils/hooks/is-mount";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import {Permissions} from "../../utils/Permissions/Permissions";
import styles from "./style.module.scss";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import {
  IExportAreaExcel,
  colomnsExportAreaExcel,
} from "../../models/area/request";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
interface IProps {
  children?: React.ReactNode;
}

const JopTile: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [exportModalVisible, setExportModalVisible] = useState(false);

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(AreaContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("areas")}
        subTitle={t("areas_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                setExportModalVisible(true);
              }}
              icon={<FileExcelOutlined />}
            >
              {t("export_to_excel")}
            </Button>
          </Can>,
          <Divider key={5} type="vertical" />,
          <Can key={3} perform={Permissions.CAN_CREATE_AREA}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/areas/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_area")}
            </Button>
          </Can>,
        ]}
      />
      <ExportToExcelModal
        id="export-category"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            city: false,
            name: false,
            note: false,
            status: false,
          } as IExportAreaExcel
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          await actions.exportExcel(columnsNames);
          setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel names={colomnsExportAreaExcel} />
      </ExportToExcelModal>
      <SearchFilterCard
        formId="area-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <AreaFilter />
      </SearchFilterCard>

      <AreaTable />
    </div>
  );
};

const AreaPage = () => {
  return (
    <AreaContextProvider>
      <JopTile />
    </AreaContextProvider>
  );
};
export default AreaPage;
